import react, {useEffect, useState} from 'react';
import Loader from "../../../../Loader/Loader";
import React from "react";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import './pjp.css'
import NotFoundData from "../../../../Images/no-data-found.webp";
import {toast} from "react-toastify";

const PJPSubmission = ({
                           history,
                           getAM,
                           allAm = [],
                           amTollDetails = [],
                           getAMTollByUserId,
                           monthlyPlan = [],
                           amMonthlyPlan,
                           match
                       }) => {

    const date = new Date();
    let nextMonthFirstDay = new Date(date.getFullYear(), date.getMonth() + 2, 1);
    let nextMonthDate = new Date(date);
    nextMonthDate.setMonth(nextMonthDate.getMonth(), 1);

    const [isLoading, setIsLoading] = useState(false)
    const [amTolls, setAmTolls] = useState([])
    const [inputList, setInputList] = useState([])
    const [showFade, setShowFade] = useState([])
    const [userId, setUserId] = useState([])

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getAM();
            setIsLoading(false)
        })();
    }, []);

    const handleFetchTollDetails = async (userId) => {
        setIsLoading(true)
        setAmTolls([])
        setUserId(userId)
        showFade[userId] = "show active";
        if (match?.params?.user_id) {
            await getAMTollByUserId(userId)
        } else {
            await getAMTollByUserId(userId)
        }

        setIsLoading(false)
    }

    useEffect(() => {
        console.log(amTollDetails)
        if (amTollDetails?.data && amTollDetails?.data?.self_toll && amTollDetails?.data?.self_toll?.length > 0) {
            // eslint-disable-next-line no-unused-expressions,array-callback-return
            amTollDetails?.data?.self_toll.map((val, i) => {
                if (!amTolls[val?.id]) {
                    amTolls[val?.id] = [];
                    amTolls[val?.id][0] = val;
                }
                if (!showFade[val?.assigned_to]) {
                    showFade[val?.assigned_to] = "";
                }
            });
            setShowFade(showFade)
            setAmTolls(amTolls)
        }
    }, [amTollDetails])

    const handleAddToll = (id) => {
        const list = amTolls[id][0];
        amTolls[id][amTolls[id].length] = {
            id: list?.id,
            client_name: list?.client_name,
            fast_tag_toll_no: list?.fast_tag_toll_no,
            state_name: list?.state_name,
            city_name: list?.city_name,
        }
        setTimeout(() => {
            setIsLoading(true)
            setAmTolls(amTolls)
            setIsLoading(false)
        }, 100)
    }

    const handleRemoveToll = (id, index) => {
        const list = [...amTolls]
        delete list[id][index];
        setAmTolls(list);
    }

    const handleInput = (date, id) => {
        inputList[inputList.length] = {account_id: id, date: date}
        setInputList(inputList)
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const list = {};
        list['user_id'] = userId;
        list['plan_dates'] = inputList;
        setIsLoading(true)
        await amMonthlyPlan(list)
        setIsLoading(false)
    }

    useEffect(() => {
        if (monthlyPlan?.status === 200) {
            toast.success(monthlyPlan?.message)
            setTimeout(() => {
                window.location.href = '/pjp-review'
            }, 1000)
        } else if (monthlyPlan?.status && monthlyPlan?.status !== 200) {
            toast.error(monthlyPlan?.message)
        }
    }, [monthlyPlan])

    const handleAdditionTolls = (tollId) => {
        setTimeout(() => {
            setIsLoading(true)
            let addition = [];
            // eslint-disable-next-line no-unused-expressions,array-callback-return
            amTollDetails?.data?.another_toll.map((val, i) => {
                if (parseInt(tollId) === parseInt(val?.id)) {
                    addition = val
                }
            })
            if (amTollDetails?.data && amTollDetails?.data?.self_toll) {
                let len = amTollDetails?.data?.self_toll.length;
                if (!amTollDetails['data']['self_toll'][len]) {
                    amTollDetails['data']['self_toll'][len] = []
                    amTollDetails['data']['self_toll'][len] = addition
                }

                if (!amTolls[addition?.id]) {
                    amTolls[addition?.id] = []
                    amTolls[addition?.id][0] = addition
                    setAmTolls(amTolls)
                }

                if (!showFade[addition?.assigned_to]) {
                    showFade[addition?.assigned_to] = "show active";
                }
                setShowFade(showFade)
                console.log("dddd", amTollDetails)
            }

            setIsLoading(false)
        }, 1000)
    }

    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'PJP Submission'}
                            history={history}
                        />
                        <div className="container-fluid common-bg">
                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title">Create New PJP</h4>
                                        <div className="default-tab">
                                            {allAm?.data &&
                                                <select onChange={(e) => {
                                                    handleFetchTollDetails(e.target.value)
                                                }} className="mb-5 col-md-12 col-sm-12" style={{borderRadius: "10px"}}>
                                                    <option>Select AM</option>
                                                    {allAm?.data.map((val, i) => {
                                                        return (
                                                            <>
                                                                <option
                                                                    value={val?.id}>{val?.name + "(" + val?.email + ")"}</option>
                                                            </>
                                                        )
                                                    })}
                                                </select>
                                            }

                                            {amTollDetails?.data && amTollDetails?.data?.self_toll && amTollDetails?.data?.self_toll.length > 0 &&
                                                amTollDetails?.data?.self_toll.map((val, i) => {
                                                    return (
                                                        <>
                                                            <div className="tab-content" key={i}>
                                                                <div
                                                                    className={`tab-pane fade ${showFade[val?.assigned_to]}`}
                                                                    id={`${val?.name.replaceAll(" ", "_")}`}
                                                                    role="tabpanel" key={i}>
                                                                    <div className="p-t-15">
                                                                        {amTolls[val?.id] && amTolls[val?.id].length > 0 && amTolls[val?.id].map((value, ii) => {
                                                                            return (
                                                                                <>
                                                                                    <div
                                                                                        className="col-md-12 col-sm-12 toll-list"
                                                                                        key={ii}>
                                                                                        <div
                                                                                            className="col-md-2 float-field ">
                                                                                            <input type="text"
                                                                                                   className="form-control form-control-user"
                                                                                                   placeholder=" "
                                                                                                   onChange={() => {
                                                                                                   }}
                                                                                                   value={value?.fast_tag_toll_no}
                                                                                                   required
                                                                                            />
                                                                                            <label
                                                                                                className="large-label float-lb">
                                                                                                Plaza Id
                                                                                            </label>
                                                                                        </div>
                                                                                        <div
                                                                                            className="col-md-2 float-field "
                                                                                            key={ii}>
                                                                                            <input type="text"
                                                                                                   className="form-control form-control-user"
                                                                                                   placeholder=" "
                                                                                                   onChange={() => {
                                                                                                   }}
                                                                                                   value={value?.client_name}
                                                                                                   required
                                                                                            />
                                                                                            <label
                                                                                                className="large-label float-lb">
                                                                                                Plaza Name
                                                                                            </label>
                                                                                        </div>
                                                                                        <div
                                                                                            className="col-md-2 float-field "
                                                                                            key={ii}>
                                                                                            <input type="text"
                                                                                                   className="form-control form-control-user"
                                                                                                   placeholder=" "
                                                                                                   onChange={() => {
                                                                                                   }}
                                                                                                   value={value?.city_name ?? " "}
                                                                                                   required
                                                                                            />
                                                                                            <label
                                                                                                className="large-label float-lb">
                                                                                                City
                                                                                            </label>
                                                                                        </div>
                                                                                        <div
                                                                                            className="col-md-2 float-field "
                                                                                            key={ii}>
                                                                                            <input type="text"
                                                                                                   className="form-control form-control-user"
                                                                                                   placeholder=" "
                                                                                                   onChange={() => {
                                                                                                   }}
                                                                                                   value={value?.state_name ?? " "}
                                                                                                   required
                                                                                            />
                                                                                            <label
                                                                                                className="large-label float-lb">
                                                                                                State
                                                                                            </label>
                                                                                        </div>
                                                                                        <div
                                                                                            className="col-md-2 float-field "
                                                                                            key={ii}>
                                                                                            <input type="date"
                                                                                                   className="form-control form-control-user"
                                                                                                   placeholder=" "
                                                                                                   required
                                                                                                   onChange={(e) => {
                                                                                                       handleInput(e.target.value, val?.id)
                                                                                                   }}
                                                                                                // min={nextMonthDate.toISOString().split('T')[0]}
                                                                                                   min={new Date().toISOString().split('T')[0]}
                                                                                                   max={nextMonthFirstDay.toISOString().split('T')[0]}
                                                                                            />
                                                                                            <label
                                                                                                className="large-label float-lb">
                                                                                                Date
                                                                                            </label>
                                                                                        </div>
                                                                                        <div
                                                                                            className="btn-box mb-4 ml-add-on-toll-list"
                                                                                            style={{"width": "100%"}}
                                                                                            key={i}>
                                                                                            <i className="fa fa-minus mt-2"
                                                                                               aria-hidden="true"
                                                                                               onClick={(e) => handleRemoveToll(value?.id, ii)}
                                                                                               key={i}
                                                                                            >
                                                                                            </i>
                                                                                            <i className="fa fa-plus mt-2 ml-2 add-toll"
                                                                                               aria-hidden="true"
                                                                                               onClick={(e) => handleAddToll(value?.id)}
                                                                                               key={i}
                                                                                            >
                                                                                            </i>
                                                                                        </div>
                                                                                    </div>

                                                                                </>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                </div>
                                                                {amTolls[val?.id] &&
                                                                    <hr className="mb-4 bg-black"/>
                                                                }

                                                            </div>

                                                        </>
                                                    )
                                                })
                                            }
                                            {amTollDetails?.data && amTollDetails?.data?.another_toll && amTollDetails?.data?.another_toll.length > 0 &&
                                                <select onChange={(e) => {
                                                    handleAdditionTolls(e.target.value)
                                                }} className="selectpicker mb-5 col-md-12 col-sm-12"
                                                        style={{borderRadius: "10px"}}>
                                                    <option>Addition Tolls</option>
                                                    {amTollDetails?.data?.another_toll.map((val, i) => {
                                                        return (
                                                            <>
                                                                <option
                                                                    value={val?.id}>{val?.client_name + "(" + val?.fast_tag_toll_no + ")"}</option>
                                                            </>
                                                        )
                                                    })}
                                                </select>
                                            }
                                            {amTollDetails?.data && amTollDetails?.data?.self_toll && amTollDetails?.data?.self_toll.length === 0 &&
                                                <div className="text-center">
                                                    <img src={NotFoundData} className="not-found-data"
                                                         alt={"not found"}/>
                                                    <div style={{fontSize: "large", fontWeight: "400"}}>
                                                        No tolls mapped
                                                    </div>
                                                </div>
                                            }
                                            {amTollDetails?.data && amTollDetails?.data?.self_toll && amTollDetails?.data?.self_toll.length > 0 &&
                                                <div className="d-flex">
                                                    <button
                                                        className="btn btn-sm btn-primary ml-3"
                                                        onClick={(e) => {
                                                            handleSubmit(e)
                                                        }}
                                                    >
                                                        Save
                                                    </button>
                                                    <button
                                                        className="btn btn-sm btn-primary ml-3"
                                                        onClick={(e) => {
                                                            handleFetchTollDetails(userId)
                                                        }}
                                                    >
                                                        Reset
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PJPSubmission